import { useState, useEffect } from "react";
import { getPlatformRuntime, isNativeApp } from "@/platform";

export function useKeyboard() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const configureKeyboardListener = async () => {
      if (!isNativeApp()) return;

      const runtime = getPlatformRuntime();
      const showListener = await runtime.keyboard.onWillShow(() => {
          setIsVisible(true);
        });

      // Add a didShow listener to catch cases where keyboard is already visible on mount
      const didShowListener = await runtime.keyboard.onDidShow(() => {
          setIsVisible(true);
        });

      const hideListener = await runtime.keyboard.onDidHide(() => {
        const timeoutId = setTimeout(() => {
          setIsVisible(false);
        }, 100);
        return () => clearTimeout(timeoutId);
      });

      return () => {
        showListener.remove();
        didShowListener.remove();
        hideListener.remove();
      };
    };

    configureKeyboardListener();
  }, []);

  return {
    isVisible,
  };
}

export default useKeyboard;
